var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"express-vue-insurance",class:_vm.setSiteSpecific.isStudent && 'student-policy'},[_c('router-view',{attrs:{"id":"insurance","defaultSite":this.setSiteSpecific}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }